import Moment from "react-moment";
import moment from "moment-timezone";
import { Box } from "@mui/material";

/**
 * The UTC twin of NiceDate: same absolute format, same muted "· 3 days ago"
 * suffix, but the timestamp is rendered in UTC rather than the browser's zone.
 *
 * The relative half is identical either way -- "3 days ago" does not depend on
 * which zone you print the instant in.
 *
 * Also guards validity, which this component previously did not: an unparseable
 * value used to render the literal string "Invalid date" on the page.
 *
 * @param {object} props
 * @param {boolean} [props.relative=false] - Opt IN to append the relative form.
 */
const NiceDateUTC = (props) => {
  const input = props.children;

  if (!input) return null;

  const dateToDisplay = moment(input).utc();
  if (!dateToDisplay.isValid()) return null;

  const absolute = <Moment format="DD-MMM-YYYY HH:mm:ss">{dateToDisplay}</Moment>;

  if (props.relative !== true) {
    return absolute;
  }

  return (
    <Box component="span" sx={{ whiteSpace: "nowrap" }}>
      {absolute}
      <Box component="span" sx={{ color: "text.secondary", marginLeft: "0.4rem" }}>
        {"· "}
        <Moment fromNow>{dateToDisplay}</Moment>
      </Box>
    </Box>
  );
};

export default NiceDateUTC;
